<template>
  <div>
    <item-comment v-for="item in comments" :key="item.id" :comment="item" @reloadComments="reloadComments" />

    <div
      v-if="haveShowAll"
      @click="seeAll"
      class="row col-12 text-black-50 see-more d-flex justify-content-center"
    >
      <small>Ver Todos</small>
    </div>

  </div>
</template>

<script>
import Axios from 'axios'
import ItemComment from './ItemComment'

export default {
  props: {
    postID: {
      required: true
    },
    commentsArray: {
      required: false
    }
  },
  components: {
    'item-comment': ItemComment
  },
  data () {
    return {
      comments: [],
      haveShowAll: false
    }
  },
  methods: {
    seeAll: function () {
      this.comments = this.commentsArray
      this.haveShowAll = false
    },

    reload: function (nopg=false) {
      Axios.get('/comments',{
        params: {
          post: this.postID,
          pg: 'nopg',
        }
      })
        .then( res => {
          this.comments = res.data.data
          this.haveShowAll = false
        })
        .catch( err => {
          console.error( err )
        })
    },

    reloadComments: function () {
      this.reload()
    },

    seeingComments: function () {

    }
  },
  mounted () {
    if ( this.commentsArray.length > 0 )
      this.comments = this.commentsArray.slice(0, 2)
      this.haveShowAll = this.commentsArray.length > 2
  }
}
</script>
